<div class="panel-body" *ngIf="activeFile?.type else emptyTemplate">
  <div class="row mb-lg">
    <div class="col-xs-12 mb-3">
      <strong>{{EN[activeFile?.type]}}</strong>
    </div>
  </div>
  <div class="row mb-lg">
    <div class="col-md-7 img-preview-wrapper">
      <div style="width: 100%" *ngIf="activeFile?.type !== 'DIGITALFILE_A_IMG_BRAND_LOGO_EPS' &&
                  activeFile?.type !== 'DIGITALFILE_D_IMG_MEDIA' &&
                  activeFile?.type !== 'DIGITALFILE_A_CARDAGRMNT' &&
                  activeFile?.type !== 'DIGITALFILE_O_IMG_MEDIA' &&
                  activeFile?.type !== 'DIGITALFILE_O_CARDAGRMNT'">
        <div style="width: 100%">
          <div class="dnd-wrapper">
            <h6 class="text-center" *ngIf="isEditable">Drag and drop file here</h6>
            <div class="text-center fs-8">Do not Drag and Drop or Upload from Zipped File, you must download first</div>

            <ngx-dropzone (change)="onUpload($event.addedFiles)"
                          style="height: 260px; overflow: visible;"
                          [disabled]="!isEditable || !fullView"
                          [multiple]="false">
              <ngx-dropzone-label>
                <ng-container *ngIf="activeFile?.item?.fileContent; else dndImagePlaceholder">
                  <img class="img-preview"
                       [ngClass]="{'zoomIn': isZoomIn}"
                       (mouseleave)="isZoomIn = false"
                       (click)="onZoomIn(); $event.preventDefault(); $event.stopPropagation()"
                       [src]="activeFile?.item.fileContent"
                  >
                </ng-container>
              </ngx-dropzone-label>
            </ngx-dropzone>
          </div>
          <div class="img-preview-name"><i>Current File</i>
            <div style="display: inline-block" *ngIf="activeFile?.item?.fileName"> - <strong>{{activeFile?.item.fileName}}</strong>
              <span class="download-link" (click)="onDownload()"> (Download)</span>
              <a class="download-link" href="" #download></a>
            </div>
          </div>
        </div>
      </div>

      <div style="width: 100%;" *ngIf="activeFile?.type === 'DIGITALFILE_A_IMG_BRAND_LOGO_EPS' ||
                  activeFile?.type === 'DIGITALFILE_D_IMG_MEDIA' ||
                  activeFile?.type === 'DIGITALFILE_A_CARDAGRMNT' ||
                  activeFile?.type === 'DIGITALFILE_O_IMG_MEDIA' ||
                  activeFile?.type === 'DIGITALFILE_O_CARDAGRMNT'">
        <div style="text-align: center">
          <div class="dnd-wrapper">
            <h6 class="text-center" *ngIf="isEditable">Drag and drop file here</h6>
            <div class="sub-title text-center">Do not Drag and Drop or Upload from Zipped File, you must download first</div>
            <ngx-dropzone (change)="onUpload($event.addedFiles)"
                          style="height: 260px; overflow: visible;"
                          [disabled]="!isEditable || !fullView"
                          [multiple]="false">
              <ngx-dropzone-label>
                <div *ngIf="activeFile?.item; else noFile">
                  <span class="fa df-icon fa-file-picture-o" *ngIf="activeFile?.type === 'DIGITALFILE_A_IMG_BRAND_LOGO_EPS'"></span>
                  <span class="fa df-icon fa-file-movie-o" *ngIf="activeFile?.type === 'DIGITALFILE_D_IMG_MEDIA'"></span>
                  <span class="fa df-icon fa-file-pdf-o" *ngIf="activeFile?.type === 'DIGITALFILE_A_CARDAGRMNT'"></span>
                  <span class="fa df-icon fa-file-movie-o" *ngIf="activeFile?.type === 'DIGITALFILE_O_IMG_MEDIA'"></span>
                  <span class="fa df-icon fa-file-pdf-o" *ngIf="activeFile?.type === 'DIGITALFILE_O_CARDAGRMNT'"></span>
                </div>
              </ngx-dropzone-label>
            </ngx-dropzone>
          </div>
          <div class="img-preview-name"><i>Current File</i>
            <div style="display: inline-block" *ngIf="activeFile?.item?.fileName"> - <strong>{{activeFile.item.fileName}}</strong>
              <span class="download-link" (click)="onDownload()"> (Download)</span>
              <a class="download-link" href="" #download></a>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-md-5" *ngIf="digitalFiles?.length">
      <tree-root #tree [nodes]="digitalFiles"
                 (activate)="onShowImagePreview($event.node.data)"
                 (initialized)="onExpandActiveParentNode(tree)"
                 (updateData)="onExpandActiveParentNode(tree)">
        <ng-template #treeNodeTemplate let-node>
          <em class="fa fa-fw"
              [ngClass]="{'fa-check' : node.data?.item, 'fa-times': !node.data?.item}"></em>
          <span matTooltip="{{EN[node.data?.type]}}"
              [ngStyle]="{'font-weight': prominentFiles.includes(node.data?.type) ? 'bold' : 'normal'}"
          >{{ EN[node.data?.type] }}</span>
        </ng-template>
        <ng-template #loadingTemplate></ng-template>
      </tree-root>
    </div>
  </div>
  <br/>
  <div class="row" *ngIf="fullView">
    <div class="col-sm-12" *ngIf="!isActionsDisabled">
      <div class="upload">
        <label [for]="'upload-input-' + fileGroup + viewLevel" class="btn btn-primary" [ngClass]="{'disabled': !isEditable}">Upload</label>
        <input type="file"
               [id]="'upload-input-' + fileGroup + viewLevel"
               [disabled]="!isEditable"
               class="upload-input"
               #inputFile
               (change)="onUpload($event.target?.files)"
               [accept]="appConfig.data.uploadFileContentType.join()"
          >
      </div>

      <button style="margin-left: 5px" class="mb-sm btn btn-danger"
              [disabled]="!isEditable || !activeFile.item"
              (click)="onRemove()">Remove</button>
    </div>
  </div>
</div>

<ng-template #emptyTemplate>
  <div class="panel-body">
    <p>No fields in product level</p>
  </div>
</ng-template>

<ng-template #dndImagePlaceholder>
  <img class="img-preview noZoom" [src]="'assets/img/no-image.png'">
</ng-template>

<ng-template #noFile>
  <img class="img-preview noZoom" [src]="'assets/img/no-file.png'">
</ng-template>
